module.exports = __webpack_public_path__ + "img/investing-dark.001e9d61.svg";